import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const openLine = () => {
    // 直接導向 LINE 官方帳號
    window.open('https://line.me/R/ti/p/@939rzwem', '_blank');
    setIsMenuOpen(false);
  };

  const isHomePage = location.pathname === '/';

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <Link to="/" className="text-2xl font-bold text-blue-600 hover:text-blue-700">
              好野貸
            </Link>
          </div>
          
          <nav className="hidden md:flex space-x-8">
            <Link
              to="/"
              className={`font-medium transition-colors duration-200 ${
                location.pathname === '/' ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
              }`}
            >
              首頁
            </Link>
            <Link
              to="/services"
              className={`font-medium transition-colors duration-200 ${
                location.pathname === '/services' ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
              }`}
            >
              成功案例
            </Link>
            <Link
              to="/about"
              className={`font-medium transition-colors duration-200 ${
                location.pathname === '/about' ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
              }`}
            >
              關於我們
            </Link>
            {isHomePage && (
              <>
                <button
                  onClick={openLine}
                  className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200"
                >
                  聯絡我們
                </button>
              </>
            )}
          </nav>

          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-blue-600 focus:outline-none"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <Link
                to="/"
                className={`block px-3 py-2 text-base font-medium rounded-md w-full text-left ${
                  location.pathname === '/' ? 'text-blue-600 bg-blue-50' : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                首頁
              </Link>
              <Link
                to="/services"
                className={`block px-3 py-2 text-base font-medium rounded-md w-full text-left ${
                  location.pathname === '/services' ? 'text-blue-600 bg-blue-50' : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                成功案例
              </Link>
              <Link
                to="/about"
                className={`block px-3 py-2 text-base font-medium rounded-md w-full text-left ${
                  location.pathname === '/about' ? 'text-blue-600 bg-blue-50' : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                關於我們
              </Link>
              {isHomePage && (
                <>
                  <button
                    onClick={openLine}
                    className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md w-full text-left"
                  >
                    聯絡我們
                  </button>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;